var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "TcLoginPublic h-full" },
    [
      _vm.insc_event
        ? _c("TcEventInscription", { attrs: { event: _vm.insc_event } })
        : _c(
            "div",
            {
              staticClass:
                "container px-10 mx-auto flex justify-center gap-5 py-5"
            },
            [
              _c("div", { staticClass: "filter w-1/4" }, [
                _c("h2", { staticClass: "font-medium ff-medium text-2xl" }, [
                  _vm._v("Filtrar eventos")
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "mt-5" },
                  _vm._l(_vm.categories, function(category, i) {
                    return _c("li", { key: i, staticClass: "mb-5" }, [
                      _c(
                        "label",
                        { staticClass: "flex items-center select-none" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: category.selected,
                                expression: "category.selected"
                              }
                            ],
                            staticClass: "h-5 w-5 mr-2",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(category.selected)
                                ? _vm._i(category.selected, null) > -1
                                : category.selected
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$a = category.selected,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          category,
                                          "selected",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          category,
                                          "selected",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(category, "selected", $$c)
                                  }
                                },
                                function($event) {
                                  return _vm.filterByCategory($event)
                                }
                              ]
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              staticClass: "h-6 w-6 mr-2",
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24"
                              }
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "12",
                                  cy: "12",
                                  r: "12",
                                  fill: category.color
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(category.name))])
                        ]
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list w-3/4" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "search flex w-full bg-white p-3 mb-5 gap-5"
                    },
                    [
                      _c("div", { staticClass: "flex-1" }, [
                        _c("input", {
                          staticClass: "w-full h-full px-3",
                          attrs: { type: "search", placeholder: "Buscar" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-1 flex items-center" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "h-5 w-5",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d:
                                  "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selected_date_ini,
                                expression: "selected_date_ini"
                              }
                            ],
                            staticClass: "w-full h-full",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selected_date_ini = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Fecha de inicio")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.datesIni, function(date, i) {
                              return _c("option", { key: i }, [
                                _vm._v(_vm._s(date))
                              ])
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex-1 flex items-center" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "h-5 w-5",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24",
                              stroke: "currentColor"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d:
                                  "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selected_date_end,
                                expression: "selected_date_end"
                              }
                            ],
                            staticClass: "w-full h-full",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selected_date_end = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Fecha de fin")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.datesEnd, function(date, i) {
                              return _c("option", { key: i }, [
                                _vm._v(_vm._s(date))
                              ])
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "w-4" }),
                      _vm._v(" "),
                      _c("button", { staticClass: "px-10 py-3 text-base" }, [
                        _vm._v("Buscar")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.events, function(event, i) {
                    return _c("TcEventItem", {
                      key: i,
                      staticClass: "mb-3",
                      attrs: { event: event }
                    })
                  }),
                  _vm._v(" "),
                  _vm.events.length == 0
                    ? _c("div", { staticClass: "text-bold text-center" }, [
                        _vm._v("NO SE HAN ENCONTRADO EVENTOS")
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          ),
      _vm._v(" "),
      _vm.selected_event
        ? _c("TcEventShow", { attrs: { event: _vm.selected_event } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }